import styled from 'styled-components'

export const SongTitle = styled.span`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
`
